import { gql } from '@apollo/client'

export const UsernameAvailable = gql`
    query UsernameAvailable($username: String!) { usernameAvailable(username: $username) }
`

export default UsernameAvailable
